export const calculateAverageCenter = (clusters, defaultCenter) => {
    let latSum = 0;

    let lonSum = 0;

    clusters.forEach(({ geometry }) => {
        /* Rough approximation of center point by averaging incoming
        events lat lon values */
        const lng = geometry.coordinates[0];
        const lat = geometry.coordinates[1];

        latSum += parseFloat(lat);
        lonSum += parseFloat(lng);
    });

    let center = {
        lat: latSum / clusters.length,
        lng: lonSum / clusters.length,
    };

    if (!latSum || !lonSum) {
        center = defaultCenter;
    }

    return center;
};

export const convertEventsToGeoJSON = (events) =>
    // map events to objects that meet GeoJSON spec
    events.map((event) => ({
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [event.longitude, event.latitude],
        },
        properties: {
            name: event.name,
            id: event.id,
            startDate: event.startDate,
            startTime: event.startTime,
            venueName: event.venueName,
            venueAddress: event.venueAddress,
            minPrice: event.minPrice,
            url: event.url,
            imageUrl: event.imageUrl,
            isFree: event.isFree,
            ticketsBy: event.ticketsBy,
            savedByYou: event.savedByYou,
            repeatingInstanceCount: event.repeatingInstanceCount,
        },
    }));

export const isSingleCluster = (clusters) =>
    clusters.length === 1 ? clusters[0].properties.cluster_id : null;

export const getLatLngsFromEvents = (events) =>
    events.map(({ latitude, longitude }) => ({
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
    }));
